import { render } from "./MenuGroup.vue?vue&type=template&id=e2e3ffb6&scoped=true"
import script from "./MenuGroup.vue?vue&type=script&lang=ts"
export * from "./MenuGroup.vue?vue&type=script&lang=ts"

import "./MenuGroup.vue?vue&type=style&index=0&id=e2e3ffb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2e3ffb6"

export default script